"use strict";
var http_1 = require("@angular/http");
var rxjs_1 = require("rxjs");
var BhtpBaseService = (function () {
    function BhtpBaseService() {
        this.baseUrl = '';
        this.defaultContentType = 'application/json';
    }
    BhtpBaseService.prototype.setOrigin = function (origin) {
        this.origin = origin;
    };
    BhtpBaseService.prototype.setDefaultContentType = function (contentType) {
        this.defaultContentType = contentType;
    };
    BhtpBaseService.prototype.setWhiteLabelPartner = function (partner) {
        this.whiteLabelPartner = partner;
    };
    BhtpBaseService.prototype.setAuthToken = function (token) {
        this.authToken = token;
    };
    BhtpBaseService.prototype.setBaseUrl = function (baseUrl) {
        this.baseUrl = baseUrl;
    };
    BhtpBaseService.prototype.getFullUrl = function (endpoint) {
        var delimeter = '/';
        var base = this.baseUrl;
        var appendedEndpoint = endpoint;
        if (lastCharacterInStringIsCharacter(base, delimeter)) {
            base = base.substr(0, base.length - 1);
        }
        if (firstCharacterInStringIsCharacter(appendedEndpoint, delimeter)) {
            appendedEndpoint = appendedEndpoint.substr(1, appendedEndpoint.length);
        }
        return base + delimeter + appendedEndpoint;
        function lastCharacterInStringIsCharacter(source, target) {
            return source && target && source.lastIndexOf(target) === source.length - target.length;
        }
        function firstCharacterInStringIsCharacter(source, target) {
            return source && target && source.indexOf(target) === 0;
        }
    };
    /**
     *  Not intended for use outside the module, though it can be.
     *      Tests the existingOptions passed in; if it exists, the current options object is used.
     *
     *      If the header already exists, the value is replaced if not specified. If told not to replace,
     *          the value is added on to the existing value, and the value must be treated as a CSV.
     *      http://stackoverflow.com/questions/4371328/are-duplicate-http-response-headers-acceptable
     *
     * @param existingOptions Angular2 RequestOptionsArgs; if you already have one, this will reuse it.  If not, one will be created and returned through the method.
     * @param headerName The name of the header to either add, replace, or append a value to.
     * @param headerValue The value of the header to either add, replace, or append to an existing value.
     */
    BhtpBaseService.prototype.setAppendRequestHeader = function (existingOptions, headerName, headerValue, replaceExistingHeader) {
        if (replaceExistingHeader === void 0) { replaceExistingHeader = true; }
        var options = existingOptions ? existingOptions : new http_1.RequestOptions();
        // add headers object if it is missing.
        if (!options.headers) {
            options.headers = new http_1.Headers();
        }
        // if the header exists and we're not replacing it (appending to it)...
        if (options.headers.has(headerName) && !replaceExistingHeader) {
            // if not replacing, append a comma and the value passed in to the current value.
            options.headers.append(headerName, headerValue);
        }
        else {
            // the header does not exist.  add it.
            options.headers.set(headerName, headerValue);
        }
        return options;
    };
    /**
     * Adds an Authorization header with the given token.
     * @param token the authorization token to add as a header.
     * @param existingOptions Angular2 RequestOptionsArgs; if you already have one, this will reuse it.  If not, one will be created and returned through the method.
     */
    BhtpBaseService.prototype.addAuthorizationToken = function (existingOptions, token) {
        if (!token) {
            token = this.authToken;
        }
        return this.setAppendRequestHeader(existingOptions, 'Authorization', "Bearer " + token);
    };
    /**
     * Adds an Accept & Content-Type header. Defaults to 'application/json' unless default was overridden with setDefaultContentType()
     * @param contentType the content type to append to the headers list.
     * @param existingOptions Angular2 RequestOptionsArgs; if you already have one, this will reuse it.  If not, one will be created and returned through the method.
     */
    BhtpBaseService.prototype.getStandardRequestOptions = function (contentType, existingOptions) {
        if (contentType === void 0) { contentType = null; }
        if (!contentType) {
            contentType = this.defaultContentType;
        }
        var options = this.setAppendRequestHeader(existingOptions, 'Accept', contentType);
        options = this.setAppendRequestHeader(options, 'Content-Type', contentType);
        options = this.setAppendRequestHeader(options, 'X-Bhtp-Origin', this.origin);
        options = this.setAppendRequestHeader(options, 'X-Bhtp-WhiteLabelPartner', this.whiteLabelPartner);
        return options;
    };
    BhtpBaseService.prototype.handleError = function (error) {
        var obj;
        if (error instanceof http_1.Response) {
            obj = error.json();
        }
        else {
            obj = error;
        }
        return rxjs_1.Observable.throw(obj);
    };
    return BhtpBaseService;
}());
exports.BhtpBaseService = BhtpBaseService;
//# sourceMappingURL=D:/a/1/s/base/src/base-service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/base-service.js